<template>
  <v-container class="main-page">
    <v-row>
      <v-col
        md="10"
        offset-md="1"
      >
        <h1 class="PCTitle">
          {{ $t('payment_confirmation.txt.title') }}
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        md="10"
        offset-md="1"
      >
        <span class="PCSubtitle">
          {{ $t('payment_confirmation.txt.subtitle') }}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        md="10"
        offset-md="1"
      >
        <v-card class="card">
          <v-card-text class="card-description">
            {{ $t('payment_confirmation.txt.card_description') }}
          </v-card-text>

          <v-card-text class="card-description-bold">
            {{ $t('payment_confirmation.txt.card_description_bold') }}
          </v-card-text>

          <v-btn
            class="card-button"
            :to="{ name: 'home'}"
          >
            {{ $t('payment_confirmation.txt.proceed') }}
          </v-btn>
          <v-img
            :src="$t('payment_confirmation.img.truck.img')"
            :alt="$t('payment_confirmation.img.truck.alt')"
            class="truck"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PaymentConfirmation'
}
</script>

<style scoped>
.main-page {
  max-width: 66%;
  margin-left: 16.25%;
}

.truck {
  right: 0;
  top: 50%;
  margin-right: -116px;
  margin-top: -147px;
  width: 232px;
  height: 294px;
  position: absolute;
}

.PCTitle {
  margin-top: 2.25%;
  font-family: HelveticaNeue;
  font-size: 48px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a202c;
}

.PCSubtitle {
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #4a5568;
}

.card {
  min-height: 326px;
}

.card-description {
  padding: 32px 116px 8px 32px;
  min-width: 100%;
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #4a5568 !important;
}

.card-description-bold {
  padding: 8px 116px 8px 32px;
  min-width: 100%;
  font-family: HelveticaNeue;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1a202c !important;
}

.card-button {
  margin: 16px 116px 16px 32px;
  width: 30%;
  height: 48px !important;
  border-radius: 5px;
  box-shadow: 0 2px 5px -7px rgba(0, 0, 0, 0.19),
    0 1px 1px 0 rgba(0, 0, 0, 0.25), inset 0 1px 2px 0 rgba(255, 255, 255, 0.69);
  border: solid 1px #2c5282;
  background-color: #005ca9 !important;
  font-family: HelveticaNeue;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
  opacity: 0;
}
</style>